import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Header.st.css.js';
import Heading from '../../../Heading';
import Text from '../../../Text';
import { DATA_HOOKS } from './Header.constants';
import { isString } from '../../../utils/StringUtils';
const Header = ({ dataHook, title, subtitle, suffix, className }) => {
    return (React.createElement("div", { "data-hook": dataHook, className: st(classes.root, {}, className) },
        React.createElement("div", { className: classes.titleWrapper },
            isString(title) ? (React.createElement(Heading, { dataHook: DATA_HOOKS.title, size: "medium", children: title, className: classes.title })) : (React.createElement("span", { "data-hook": DATA_HOOKS.title }, title)),
            subtitle && isString(subtitle) ? (React.createElement(Text, { dataHook: DATA_HOOKS.subtitle, children: subtitle, secondary: true })) : (React.createElement("span", { "data-hook": DATA_HOOKS.subtitle }, subtitle))),
        suffix && (React.createElement("div", { "data-hook": DATA_HOOKS.suffix, className: classes.suffix, children: suffix }))));
};
Header.displayName = 'Card.Header';
Header.propTypes = {
    dataHook: PropTypes.string,
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node,
    suffix: PropTypes.node,
    className: PropTypes.string,
};
export default Header;
//# sourceMappingURL=Header.js.map